// Persistent anonymous visitor id used to dedup ad impression/click tracking
// (so rapid refreshes don't inflate stats). Not used for any personal tracking.
export function getVisitorId() {
  try {
    let vid = localStorage.getItem('if_vid');
    if (!vid) {
      vid = (crypto?.randomUUID?.() || `${Date.now()}-${Math.random().toString(36).slice(2)}`);
      localStorage.setItem('if_vid', vid);
    }
    return vid;
  } catch {
    return '';
  }
}
